import script from "./GetZone.vue?vue&type=script&setup=true&lang=ts"
export * from "./GetZone.vue?vue&type=script&setup=true&lang=ts"

import "./GetZone.vue?vue&type=style&index=0&id=48387016&scoped=true&lang=css"

import exportComponent from "/home/tobias/code/github.com/RemondisDigitalServices/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48387016"]])

export default __exports__